import { proceduresConstants } from '../constants';
import {List} from "immutable";

export function procedures(state = {}, action) {
  switch (action.type) {
    case proceduresConstants.GETPROCEDRURES_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        data: new List()
      });
    case proceduresConstants.GETPROCEDRURES_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data
      });
    case proceduresConstants.GETPROCEDRURES_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state
  }
}
